"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_quill_1 = __importDefault(require("react-quill"));
require("./styles/quill.dark.css");
require("./styles/quill.snow.css");
var configurationTypes_1 = require("../../../shared/types/configurationTypes");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var getColumnEditLayout_1 = __importDefault(require("../../../shared/util/getColumnEditLayout"));
var getValueForColumn_1 = __importDefault(require("../util/getValueForColumn"));
var LabelWithTooltipComponent_1 = __importDefault(require("../../../shared/components/MessageComponents/LabelWithTooltipComponent"));
var styles_1 = require("@mui/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    label: {
        color: theme.typography.caption.color,
        fontSize: theme.typography.caption.fontSize,
    },
    editor: {},
}); });
var CrudeRichTextEditorComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var entity = props.entity;
    var classes = useStyles();
    var theme = react_redux_1.useSelector(crude_selector_1.getTheme);
    var useDarkMode = react_redux_1.useSelector(crude_selector_1.darkMode);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var editLayout = react_redux_1.useSelector(crude_selector_1.getEditLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var columnName = props.schema.name;
    var columnLabels = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entity]) === null || _b === void 0 ? void 0 : _b.columns;
    var label = (columnLabels && ((_c = columnLabels[columnName]) === null || _c === void 0 ? void 0 : _c.title)) ? (_d = columnLabels[columnName]) === null || _d === void 0 ? void 0 : _d.title : columnName;
    var description = columnLabels && ((_e = columnLabels[columnName]) === null || _e === void 0 ? void 0 : _e.description);
    var required = !props.schema.nullable;
    var disabled = props.disabled ? props.disabled : false;
    var _h = react_1.default.useState(getValueForColumn_1.default(props.schema, props.data, columnLabels)), value = _h[0], setValue = _h[1];
    react_1.useEffect(function () {
        var _a, _b;
        setValue(getValueForColumn_1.default(props.schema, props.data, columnLabels));
        ((_a = columnEditLayout === null || columnEditLayout === void 0 ? void 0 : columnEditLayout.textEditorConfiguration) === null || _a === void 0 ? void 0 : _a.toolbar) && setToolbarOptions((_b = columnEditLayout === null || columnEditLayout === void 0 ? void 0 : columnEditLayout.textEditorConfiguration) === null || _b === void 0 ? void 0 : _b.toolbar);
    }, [props.data]);
    var _j = react_1.useState(props.columnEditLayout || (editLayout && getColumnEditLayout_1.default(entity, columnName || '', editLayout))), columnEditLayout = _j[0], setColumnEditLayout = _j[1];
    var _k = react_1.useState(((_f = columnEditLayout === null || columnEditLayout === void 0 ? void 0 : columnEditLayout.textEditorConfiguration) === null || _f === void 0 ? void 0 : _f.toolbar) || ((_g = appLayout.globalInputLayouts) === null || _g === void 0 ? void 0 : _g.toolbar) ||
        ['bold', 'italic']), toolbarOptions = _k[0], setToolbarOptions = _k[1];
    var _l = react_1.useState(), replacedToolbarOptions = _l[0], setReplacedToolbarOptions = _l[1];
    react_1.useEffect(function () {
        setColumnEditLayout(props.columnEditLayout);
    }, [props.columnEditLayout]);
    react_1.useEffect(function () {
        var tempOptions = toolbarOptions && toolbarOptions.map(function (elem) {
            switch (elem) {
                case configurationTypes_1.ToolbarFontStyleElement.sub:
                    return { script: elem };
                case configurationTypes_1.ToolbarFontStyleElement.super:
                    return { script: elem };
                case configurationTypes_1.ToolbarListElement.bullet:
                    return { list: elem };
                case configurationTypes_1.ToolbarListElement.ordered:
                    return { list: elem };
                case configurationTypes_1.ToolbarAdditionalElement.color:
                    return { color: [] };
                case configurationTypes_1.ToolbarAdditionalElement.background:
                    return { background: [] };
                case configurationTypes_1.ToolbarAdditionalElement.font:
                    return { font: [] };
                case configurationTypes_1.ToolbarAdditionalElement.align:
                    return { align: [] };
                case configurationTypes_1.ToolbarAdditionalElement.header:
                    return { header: [1, 2, 3, 4, 5, false] };
                default:
                    return elem;
            }
        });
        setReplacedToolbarOptions(tempOptions);
    }, [toolbarOptions]);
    var changeData = function (val) {
        setValue(val);
        var newData = props.data;
        var newColumnData = newData.data;
        newColumnData[columnName] = val;
        newData.data = newColumnData;
        props.onChange && props.onChange(newData);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, replacedToolbarOptions &&
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: "" + label + (required ? '*' : ''), className: classes.label, description: description }),
            react_1.default.createElement(react_quill_1.default, { className: useDarkMode ? 'dark' : '', modules: { toolbar: replacedToolbarOptions }, readOnly: disabled, theme: 'snow', value: value, onChange: changeData, style: {
                    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
                    borderTop: '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                } }))));
};
exports.default = CrudeRichTextEditorComponent;
